import { render } from "./statutory-deductions.vue?vue&type=template&id=62a0fce6&scoped=true"
import script from "./statutory-deductions.vue?vue&type=script&lang=js"
export * from "./statutory-deductions.vue?vue&type=script&lang=js"

import "./statutory-deductions.vue?vue&type=style&index=0&id=62a0fce6&scoped=true&lang=css"

import exportComponent from "/home/runner/work/inventflux-frontend/inventflux-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62a0fce6"]])

export default __exports__